import React from 'react';
export default function ReferralCode() {
  return (
      <section>
  <h1>Coming soon</h1>.     </section>

      );  
};
